<template>
  <div class="ins-main g2e2018-main">
    <div class="g2e-banner">
      <template v-if="isMobile">
        <ul class="slider-mb">
          <carousel
            :perPage="1"
            :mouse-drag="false"
            :navigationEnabled="false"
            :paginationEnabled="true"
            :loop="true"
            :autoplay="true"
            :speed="1000"
            :autoplayTimeout="3000">
            <slide v-for="(banner,index) in bannerImg" :key='index'>
              <li>
                <!-- <img :src='require(`@img/hk/mobile/g2e2018/${banner.mbimg}`)'> -->
                <img :src='require(`@img/${nowLangx}/mobile/g2e2018/${banner.mbimg}`)'>
              </li>
            </slide>
          </carousel>
        </ul>
      </template>
      <template v-else>
        <ul class="slider-pc">
          <carousel
            :perPage="1"
            :mouse-drag="false"
            :navigationEnabled="true"
            :navigationNextLabel="`<span class='icon-32'></span>`"
            :navigationPrevLabel="`<span class='icon-32'></span>`"
            :paginationEnabled="false"
            :loop="true"
            :autoplay="true"
            :speed="1000"
            :autoplayTimeout="3000">
            <slide v-for="(banner,index) in bannerImg" :key='index'>
              <li>
                <img :src='require(`@img/${nowLangx}/g2e2018/${banner.pcimg}`)'>
                <!-- <img :src='require(`@img/hk/g2e2018/${banner.pcimg}`)'> -->
              </li>
            </slide>
          </carousel>  
        </ul>
      </template>
    </div>
    <div class="g2e-inner">
      <div class="video-box">
        <div class="inbox">
          <div class="narr-wrap">
            <div class="heading">
              <h2>{{$t('lang_themeHeading_onlineExhibition_2')}}</h2>
              <h3>{{$t('lang_themeHeading_onlineExhibition_subtitle')}}</h3>
            </div>
            <div class="narr-txt" v-html="$t('lang_themeHeading_onlineExhibition_msg')"></div>
          </div>
          <div class="video-bg">
            <div class="video-show" onclick="fubo.gaEvent('hk_video','click')">
                <iframe style="width:100%;height:100%;" src="https://www.youtube.com/embed/dUqA1A5iwcI" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen v-if="isYoutube"></iframe>
                <div id="youkuplayer" style="width:100%;height:100%;" v-else></div>
            </div>
          </div>
        </div>
      </div>
      <div class="exhibition-box">
        <div class="g2eHeading">
          <h2>{{$t('lang_themeHeading_exhibitionSpecial')}}</h2>
        </div>
        <div class="exhibition-slider">
          <ul>
            <carousel
              :perPage="1"
              :mouse-drag="false"
              :navigationEnabled="true"
              :navigationNextLabel="`<span class='icon-round-arrow'></span>`"
              :navigationPrevLabel="`<span class='icon-round-arrow'></span>`"
              :paginationEnabled="false"
              :loop="true"
              :autoplay="true"
              :speed="1000"
              :autoplayTimeout="3000">   
              <slide v-for="(bannerImg,index) in exhibitions" :key="index">     
                <li>
                  <div v-for="(img,item) in bannerImg.img" :key="item" :class="`penciItem penciItem-${item+1}`">
                    <div class="penciItem-holder">
                      <img :src='require(`@img/g2e2018/exhibition/${img.smallimg}`)'>
                    </div>
                  </div>
                </li>
              </slide>
            </carousel>
          </ul>
        </div>
      </div>
      <div class="g2eFocus-box">
        <div class="features-wrap">
          <div class="g2eHeading">
            <h2>{{$t('lang_themeHeading_exhibitionFocus')}}</h2>
          </div>
          <ul class="g2eFocus-list clearfix">
            <li v-for="(list,index) in focusPoints" :key='index'>
              <router-link :to="list.link">
                <div class="m-table-left">
                  <i :class="list.icon"></i>
                </div>
                <div class="m-table-right">
                  <div class="title">{{$t(`${list.title}`)}}</div>
                  <div class="narrs" v-html= $t(list.narrs)></div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
        <ul class="g2e-list clearfix">
          <li v-for="(list,index) in focusNews" :key=index>
            <div class="g2e-list-info">
              <div class="list-info-inner">
                <div class="list-info-date">
                  <span class="year">{{list.year}}</span>
                  <span class="month">{{list.month}}</span>
                  <span class="day">{{list.day}}</span>
                </div>
                <h3 v-html= $t(list.narrs)></h3>
              </div>
            </div>
            <div class="g2e-list-img">
              <i class="icon-30"></i>
              <img :src='require(`@img/g2e2018/focus/${list.img}`)'>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { Carousel, Slide } from 'vue-carousel'
import exhibition from '@data/exhibition.json'
import focusPoint from '@data/focusPoint.json'
import focusNews from '@data/g2e2018News.json'
import {mapGetters} from 'vuex'

export default {
  name: 'G2EAsia2018',
  components: {
    Carousel,
    Slide
  },
  data(){
    return{
      isMobile: false,
      deviceModel: 'pc',
      focusPoints: [],
      focusNews: [],
      exhibitions: [],
      isYoutube: false,
    }
  },
  computed: {
    bannerImg(){
      return[
        {
          pcimg: 'banner01.jpg',
          mbimg: 'banner01.jpg'
        },{
          pcimg: 'banner02.jpg',
          mbimg: 'banner02.jpg'
        }
      ]
    },
    ...mapGetters({
      defLangx: 'defLangx',
      nowLangx: 'nowLangx',
    }),
  },
  methods: {
    getWinSize(){
      const $this = this;
      $(window).resize(function(){
        if($this.deviceModel === 'mb' && $(window).width() > 996) {
          $this.isMobile = false
          $this.deviceModel = 'pc'
        }else if ($this.deviceModel === 'pc' && $(window).width() <= 996){
          $this.isMobile = true
          $this.deviceModel = 'mb'
        }
      })
      if($this.deviceModel === 'mb' && $(window).width() > 996) {
        $this.isMobile = false
        $this.deviceModel = 'pc'
      }else if ($this.deviceModel === 'pc' && $(window).width() <= 996){
        $this.isMobile = true
        $this.deviceModel = 'mb'
      }        
    },
    focusPointInfo(info){
      this.focusPoints = info
    },
    focusNewsInfo(info){
      this.focusNews = info
    },
    exhibitionInfo(info){
      this.exhibitions = info
    }
  },
  mounted() {
    this.getWinSize()
    this.focusPointInfo(focusPoint)
    this.focusNewsInfo(focusNews)
    this.exhibitionInfo(exhibition)
		this.isYoutube = this.defLangx === 'cn' ? false : true
    if(!this.isYoutube){
      $.getScript("//player.youku.com/jsapi", function() {
				var player = new YKU.Player('youkuplayer',{
					styleid: '0',
          client_id: 'a2hzp.8253869.0.0',
          vid: 'XMzY3MzY5Mjg3Mg',
          newPlayer: true
				});
			});
    }
    this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>

<style lang="sass">
  @import '@css/g2e2018.sass'
</style>